import React, { useState, useEffect } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import Checkbox from "@mui/material/Checkbox";
import {
  Tooltip,
  Typography,
  Chip,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormGroup,
  FormControlLabel,
  Button,
} from "@mui/material";
import "@fullcalendar/daygrid/main.css";
import moment from "moment";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { CircularProgress } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useSnackbar } from "notistack";
import { useNavigate, useParams } from "react-router-dom";
import EditWorkoutPopup from "src/pages/Calender/component/EditWorkoutPopup";
import { set_program_difficulty_level_api } from "src/DAL/programmeWorkout/programmeWorkout";
import { Icon } from "@iconify/react";
import { get_root_value } from "src/utils/domUtils";
import { s3baseUrl } from "src/config/config";
import CustomPopoverNew from "../CustomPopoverNew";
import { useContentSetting } from "src/Hooks/ContentContext/ContentSettingState";
import { show_proper_words } from "src/utils/constants";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

function GeneralCalendar({
  programWorkoutList,
  reorderedWorkoutList,
  setCurrentDate,
  time_zone,
  currentDate,
  isLoading,
  reloadList,
  calendar_title,
  hideArrowsAndButtons,
  programme,
  member_vdot,
  memberRewardData,
  setSubmitted,
  submitted,
  calendarRef,
  goToToday,
  levelStats,
  manualLoading,
}) {
  const [events, setEvents] = useState([]);
  const navigate = useNavigate();
  const classes = useStyles();
  const params = useParams();
  const { userInfo } = useContentSetting();
  const { enqueueSnackbar } = useSnackbar();
  const [editItrationDrawerState, setEditItrationDrawerState] = useState();
  const [editWorkputData, setEditWorkputData] = useState();
  const [openLevels, setOpenLevels] = useState(false);
  const [difficultyLevel, setDifficultyLevel] = useState("");
  const [tempDifficultyLevel, setTempDifficultyLevel] = useState("");
  const [checked, setChecked] = useState(false);
  const globalOpenRef = React.useRef(true);

  const handleChangeCheck = (event) => {
    setChecked(event.target.checked);
  };

  const getWorkoutCountForLevel = () => {
    if (
      !tempDifficultyLevel ||
      !levelStats ||
      !Array.isArray(levelStats) ||
      levelStats.length === 0
    ) {
      return 0;
    }
    const levelStat = levelStats.find(
      (stat) => stat.difficulty_level === tempDifficultyLevel,
    );
    return levelStat ? levelStat.count : 0;
  };

  const handleAddLevels = async () => {
    if (!tempDifficultyLevel) {
      return enqueueSnackbar(`Please Select Levels`, { variant: "error" });
    }
    let postData = {
      program_id: programme?._id?._id || programme?.program_info?.program_id,
      member_id: userInfo?._id,
      difficulty_level: tempDifficultyLevel,
    };
    let result = await set_program_difficulty_level_api(postData);
    if (result.code === 200) {
      enqueueSnackbar(result.message, { variant: "success" });
      setDifficultyLevel(tempDifficultyLevel);
      setOpenLevels(false);
      reloadList();
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const handleOpenEditIterationDrawer = () => {
    setEditItrationDrawerState(true);
  };

  const handleUpdateIteration = (data) => {
    setEditWorkputData(data);
    handleOpenEditIterationDrawer();
  };

  // ── NEW: Expand / Collapse all handlers ──────────────────────────────────
  const handleExpandAll = () => {
    globalOpenRef.current = true;
    setEvents((prev) => prev.map((e) => ({ ...e, open: true })));
  };

  const handleCollapseAll = () => {
    globalOpenRef.current = false;
    setEvents((prev) => prev.map((e) => ({ ...e, open: false })));
  };
  // ─────────────────────────────────────────────────────────────────────────

  const EventCard = ({ workout }) => {
    const [extra, setExtra] = useState(
      workout._def.extendedProps.workout_exercises
        .map((item) => {
          if (item.is_extra) {
            return item;
          }
          return [];
        })
        .flat(),
    );

    const formatWithLeadingZeros = (value) => {
      return value < 10 ? `0${value}` : `${value}`;
    };

    const getMinutesForInterval = (mainindex, index) => {
      const list = [...workout._def.extendedProps.workout_exercises];
      const interval = list[mainindex].interval_duration;
      if (interval <= 60) {
        return index + 1;
      }
      if (interval % 60 == 0) {
        return `${
          (interval / 60) * index +
          1 +
          " – " +
          ((interval / 60) * index + interval / 60)
        }`;
      }
      let startInterval = interval * index;
      let endtInterval = interval * index + interval;
      let startintervalText =
        interval * index
          ? Math.floor(startInterval / 60) +
            " " +
            ":" +
            formatWithLeadingZeros(startInterval % 60)
          : 0;
      let endIntervalText =
        Math.floor(endtInterval / 60) +
        " " +
        ":" +
        formatWithLeadingZeros(endtInterval % 60);
      return `${startintervalText + " – " + endIntervalText}`;
    };

    return (
      <div
        className="calendar-workout-card"
        id={workout._def.extendedProps?._id}
        style={{
          border:
            editWorkputData?._id == workout._def.extendedProps?._id
              ? "2px solid var(--portal-theme-primary)"
              : "0px solid var(--portal-theme-primary)",
        }}
      >
        <div>
          <div
            className="calendar-workout-card-title"
            style={{
              backgroundColor: workout._def.extendedProps.workout_color,
            }}
          >
            <div
              className="calendar-workout-card-program d-flex justify-content-between"
              onClick={() => handleUpdateIteration(workout._def.extendedProps)}
            >
              <div>{workout._def.extendedProps?.workout_program?.title}</div>
              {workout._def.extendedProps?.workout_completed && (
                <div className="">
                  <Icon
                    icon="fluent-mdl2:completed-solid"
                    className="workout-complete-icon-container"
                  />
                </div>
              )}
            </div>
            <div className="d-flex justify-content-between">
              <div
                className="calendar-workout-card-workout"
                onClick={() =>
                  handleUpdateIteration(workout._def.extendedProps)
                }
              >
                {workout.title}
              </div>
              <div className="d-flex align-items-center">
                <Icon
                  onClick={() =>
                    handleUpdateIteration(workout._def.extendedProps)
                  }
                  icon={
                    workout._def.extendedProps.practice_type == "workout" ||
                    workout._def.extendedProps.library_type == "workout-type"
                      ? "mdi:gym"
                      : workout._def.extendedProps.practice_type == "food" ||
                        workout._def.extendedProps.library_type == "meal-type"
                      ? "fluent:food-24-filled"
                      : workout._def.extendedProps.practice_type == "mindset" ||
                        workout._def.extendedProps.library_type ==
                          "mindset-type"
                      ? "flowbite:brain-outline"
                      : workout._def.extendedProps.practice_type == "video"
                      ? "lets-icons:video-fill"
                      : workout._def.extendedProps.practice_type == "comment"
                      ? "mdi:comment-text"
                      : "mdi:gym"
                  }
                  className="workout-type-icon-container"
                />
                {!workout._def.extendedProps?.open ? (
                  <KeyboardArrowDownIcon
                    sx={{ cursor: "pointer", opacity: 0.7, fontSize: "20px" }}
                    onClick={() => {
                      const list = [...events];
                      list[workout._def.extendedProps.index]["open"] = true;
                      setEvents(list);
                    }}
                  />
                ) : (
                  <KeyboardArrowUpIcon
                    sx={{ cursor: "pointer", opacity: 0.7, fontSize: "20px" }}
                    onClick={() => {
                      const list = [...events];
                      list[workout._def.extendedProps.index]["open"] = false;
                      setEvents(list);
                    }}
                  />
                )}
              </div>
            </div>
          </div>

          {workout._def.extendedProps?.open && (
            <div className="calendar-workout-card-exercises">
              <div
                className="calendar-workout-card-container py-1"
                onClick={() =>
                  handleUpdateIteration(workout._def.extendedProps)
                }
              >
                {workout._def.extendedProps?.practice_type == "workbook" ? (
                  <div className="inner-div workout-calendar-exercise-card my-1">
                    {workout._def.extendedProps?.workout_title}
                  </div>
                ) : null}

                {workout._def.extendedProps.practice_type == "comment" ? (
                  <div
                    className="inner-div workout-calendar-exercise-card my-1"
                    style={{
                      fontSize: "11px",
                      overflow: "hidden",
                      whiteSpace: "break-spaces",
                    }}
                  >
                    {workout._def.extendedProps?.comment || ""}
                  </div>
                ) : null}

                {workout._def.extendedProps.practice_type == "video" ? (
                  <div className="inner-div workout-calendar-exercise-card my-1">
                    {workout?._def?.extendedProps?.dumyImage ? (
                      <div
                        style={{
                          whiteSpace: "break-spaces",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          position: "relative",
                        }}
                      >
                        <img
                          className="image-border"
                          src={workout?._def?.extendedProps?.dumyImage}
                          height="50"
                        />
                        <div className="overlay-icon">
                          <Icon
                            icon={"lets-icons:video-fill"}
                            className="workout-type-icon-container"
                          />
                        </div>
                      </div>
                    ) : (
                      <div
                        style={{
                          whiteSpace: "break-spaces",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          position: "relative",
                        }}
                      >
                        <img
                          className="image-border"
                          src={
                            s3baseUrl +
                            workout?._def?.extendedProps?.video_thumbnail
                              ?.thumbnail_1
                          }
                          height="50"
                        />
                        <div className="overlay-icon">
                          <Icon
                            icon={"lets-icons:video-fill"}
                            className="workout-type-icon-container"
                          />
                        </div>
                      </div>
                    )}
                  </div>
                ) : null}

                {workout._def.extendedProps.workout_exercises.map(
                  (exercise, index) => {
                    if (!exercise.is_extra) {
                      if (exercise?.exercise_type == "something_else") {
                        return (
                          <div
                            key={index}
                            className="inner-div workout-calendar-exercise-card my-1"
                            style={{ position: "relative" }}
                          >
                            <div
                              style={{ whiteSpace: "break-spaces" }}
                              className="py-1"
                            >
                              {exercise?.is_modified && (
                                <Tooltip
                                  title={
                                    exercise?.is_modified
                                      ? "Modified"
                                      : "Not Modified"
                                  }
                                >
                                  <span
                                    style={{
                                      display: "block",
                                      position: "absolute",
                                      top: "-5px",
                                      justifyContent: "center",
                                      zIndex: "1",
                                      right: "0px",
                                    }}
                                  >
                                    <Chip
                                      label={"Modified"}
                                      variant="contained"
                                      color={"error"}
                                      sx={{
                                        fontSize: "6px",
                                        height: "auto",
                                        width: "auto",
                                        borderRadius: "3px",
                                        "& .MuiChip-label": {
                                          paddingLeft: "3px",
                                          paddingRight: "3px",
                                        },
                                      }}
                                    />
                                  </span>
                                </Tooltip>
                              )}
                              {exercise?.is_completed && (
                                <Tooltip
                                  title={
                                    exercise?.is_completed
                                      ? "Completed"
                                      : "Not Completed"
                                  }
                                >
                                  <Icon
                                    icon="fluent-mdl2:completed-solid"
                                    className="calendar-workout-card-complete-exercises-icon mb-1"
                                  />
                                </Tooltip>
                              )}
                              {exercise?.title}
                            </div>
                          </div>
                        );
                      } else if (
                        exercise?.exercise_type == "amrap" &&
                        exercise?.emom_amrap &&
                        exercise?.emom_amrap.length > 0
                      ) {
                        return (
                          <div
                            key={index}
                            className="workout-calendar-Superset-card inner-div my-1"
                          >
                            <div className="text-center">
                              {exercise?.is_completed && (
                                <Tooltip
                                  title={
                                    exercise?.is_completed
                                      ? "Completed"
                                      : "Not Completed"
                                  }
                                >
                                  <Icon
                                    icon="fluent-mdl2:completed-solid"
                                    className="calendar-workout-card-complete-exercises-icon mb-1"
                                  />
                                </Tooltip>
                              )}
                              AMRAP
                            </div>
                            {exercise?.emom_amrap?.map((interval, ii) => (
                              <div key={ii} className="my-1">
                                <div style={{ fontSize: "8px" }}>Movements</div>
                                {interval?.map((exerData, ei) => (
                                  <div
                                    key={ei}
                                    className="inner-div"
                                    style={{
                                      whiteSpace: "break-spaces",
                                      marginBottom: "3px",
                                    }}
                                  >
                                    {exerData?.exercise_info?.title}
                                  </div>
                                ))}
                              </div>
                            ))}
                          </div>
                        );
                      } else if (
                        exercise?.exercise_type == "rounds_for_time" &&
                        exercise?.emom_amrap &&
                        exercise?.emom_amrap.length > 0
                      ) {
                        return (
                          <div
                            key={index}
                            className="workout-calendar-Superset-card inner-div my-1"
                          >
                            <div className="text-center">
                              {exercise?.is_completed && (
                                <Tooltip
                                  title={
                                    exercise?.is_completed
                                      ? "Completed"
                                      : "Not Completed"
                                  }
                                >
                                  <Icon
                                    icon="fluent-mdl2:completed-solid"
                                    className="calendar-workout-card-complete-exercises-icon mb-1"
                                  />
                                </Tooltip>
                              )}
                              Rounds For Time
                            </div>
                            {exercise?.emom_amrap?.map((interval, ii) => (
                              <div key={ii} className="my-1">
                                <div style={{ fontSize: "8px" }}>Movements</div>
                                {interval?.map((exerData, ei) => (
                                  <div
                                    key={ei}
                                    className="inner-div"
                                    style={{
                                      whiteSpace: "break-spaces",
                                      marginBottom: "3px",
                                    }}
                                  >
                                    {exerData?.exercise_info?.title}
                                  </div>
                                ))}
                              </div>
                            ))}
                          </div>
                        );
                      } else if (
                        exercise?.exercise_type == "reps_for_time" &&
                        exercise?.emom_amrap &&
                        exercise?.emom_amrap.length > 0
                      ) {
                        return (
                          <div
                            key={index}
                            className="workout-calendar-Superset-card inner-div my-1"
                          >
                            <div className="text-center">
                              {exercise?.is_completed && (
                                <Tooltip
                                  title={
                                    exercise?.is_completed
                                      ? "Completed"
                                      : "Not Completed"
                                  }
                                >
                                  <Icon
                                    icon="fluent-mdl2:completed-solid"
                                    className="calendar-workout-card-complete-exercises-icon mb-1"
                                  />
                                </Tooltip>
                              )}
                              Reps For Time
                            </div>
                            {exercise?.emom_amrap?.map((interval, ii) => (
                              <div key={ii} className="my-1">
                                <div style={{ fontSize: "8px" }}>Movements</div>
                                {interval?.map((exerData, ei) => (
                                  <div
                                    key={ei}
                                    className="inner-div"
                                    style={{
                                      whiteSpace: "break-spaces",
                                      marginBottom: "3px",
                                    }}
                                  >
                                    {exerData?.exercise_info?.title}
                                  </div>
                                ))}
                              </div>
                            ))}
                          </div>
                        );
                      } else if (
                        exercise?.exercise_type == "emom" &&
                        exercise?.emom_amrap &&
                        exercise?.emom_amrap.length > 0
                      ) {
                        return (
                          <div
                            key={index}
                            className="workout-calendar-Superset-card inner-div my-1"
                          >
                            <div className="text-center">
                              {exercise?.is_completed && (
                                <Tooltip
                                  title={
                                    exercise?.is_completed
                                      ? "Completed"
                                      : "Not Completed"
                                  }
                                >
                                  <Icon
                                    icon="fluent-mdl2:completed-solid"
                                    className="calendar-workout-card-complete-exercises-icon mb-1"
                                  />
                                </Tooltip>
                              )}
                              EMOM
                            </div>
                            {exercise?.emom_amrap?.map(
                              (interval, intervalIndex) => (
                                <div key={intervalIndex} className="my-1">
                                  <div style={{ fontSize: "8px" }}>
                                    Minute{" "}
                                    {getMinutesForInterval(
                                      index,
                                      intervalIndex,
                                    )}
                                  </div>
                                  {interval?.map((exerData, ei) => (
                                    <div
                                      key={ei}
                                      className="inner-div"
                                      style={{
                                        whiteSpace: "break-spaces",
                                        marginBottom: "3px",
                                      }}
                                    >
                                      {exerData?.exercise_info?.title}
                                    </div>
                                  ))}
                                </div>
                              ),
                            )}
                          </div>
                        );
                      } else if (
                        exercise?.sub_exercises &&
                        exercise?.sub_exercises.length > 0
                      ) {
                        return (
                          <div
                            key={index}
                            className="workout-calendar-Superset-card inner-div my-1"
                          >
                            {exercise?.sub_exercises?.map(
                              (exerData, exerIndex) => (
                                <div
                                  key={exerIndex}
                                  style={{ position: "relative" }}
                                  className="my-2"
                                >
                                  <div
                                    className="inner-div"
                                    style={{
                                      whiteSpace: "break-spaces",
                                      marginBottom: "3px",
                                    }}
                                  >
                                    {exerData?.is_modified && (
                                      <Tooltip
                                        title={
                                          exerData?.is_modified
                                            ? "Modified"
                                            : "Not Modified"
                                        }
                                      >
                                        <span
                                          style={{
                                            display: "block",
                                            position: "absolute",
                                            top: "-12px",
                                            justifyContent: "center",
                                            zIndex: "1",
                                            right: "0px",
                                          }}
                                        >
                                          <Chip
                                            label={"Modified"}
                                            variant="contained"
                                            color={"error"}
                                            sx={{
                                              fontSize: "6px",
                                              height: "auto",
                                              width: "auto",
                                              borderRadius: "3px",
                                              "& .MuiChip-label": {
                                                paddingLeft: "3px",
                                                paddingRight: "3px",
                                              },
                                            }}
                                          />
                                        </span>
                                      </Tooltip>
                                    )}
                                    {exerData?.is_completed && (
                                      <Tooltip
                                        title={
                                          exerData?.is_completed
                                            ? "Completed"
                                            : "Not Completed"
                                        }
                                      >
                                        <Icon
                                          icon="fluent-mdl2:completed-solid"
                                          className="calendar-workout-card-complete-exercises-icon"
                                        />
                                      </Tooltip>
                                    )}
                                    {exerData?.exercise_info?.title}
                                  </div>
                                </div>
                              ),
                            )}
                          </div>
                        );
                      } else {
                        return (
                          <div
                            key={index}
                            className="inner-div workout-calendar-exercise-card my-1"
                            style={{ position: "relative" }}
                          >
                            <div
                              style={{ whiteSpace: "break-spaces" }}
                              className="py-1"
                            >
                              {exercise?.is_modified && (
                                <Tooltip
                                  title={
                                    exercise?.is_modified
                                      ? "Modified"
                                      : "Not Modified"
                                  }
                                >
                                  <span
                                    style={{
                                      display: "block",
                                      position: "absolute",
                                      top: "-5px",
                                      justifyContent: "center",
                                      zIndex: "1",
                                      right: "0px",
                                    }}
                                  >
                                    <Chip
                                      label={"Modified"}
                                      variant="contained"
                                      color={"error"}
                                      sx={{
                                        fontSize: "6px",
                                        height: "auto",
                                        width: "auto",
                                        borderRadius: "3px",
                                        "& .MuiChip-label": {
                                          paddingLeft: "3px",
                                          paddingRight: "3px",
                                        },
                                      }}
                                    />
                                  </span>
                                </Tooltip>
                              )}
                              {exercise?.is_completed && (
                                <Tooltip
                                  title={
                                    exercise?.is_completed
                                      ? "Completed"
                                      : "Not Completed"
                                  }
                                >
                                  <Icon
                                    icon="fluent-mdl2:completed-solid"
                                    className="calendar-workout-card-complete-exercises-icon mb-1"
                                  />
                                </Tooltip>
                              )}
                              {exercise?.exercise_info?.title}
                            </div>
                          </div>
                        );
                      }
                    }
                    return null;
                  },
                )}

                {extra && extra.length > 0 && (
                  <div>
                    <div className="text-center">
                      <Typography
                        sx={{
                          color: get_root_value("--portal-theme-primary"),
                          fontWeight: "500",
                        }}
                      >
                        <Icon icon="mdi:bicycle-electric" /> Extra Work
                      </Typography>
                      <div
                        style={{
                          whiteSpace: "break-spaces",
                          fontSize: 10,
                          opacity: 0.8,
                        }}
                      >
                        These exercises aren't part of the original workout
                      </div>
                    </div>
                    <div>
                      {extra.map((exercise, index) => {
                        if (
                          exercise?.sub_exercises &&
                          exercise?.sub_exercises.length > 0
                        ) {
                          return (
                            <div
                              key={index}
                              className="workout-calendar-Superset-card inner-div my-1"
                            >
                              {exercise?.sub_exercises?.map(
                                (exerData, exerIndex) => (
                                  <div
                                    key={exerIndex}
                                    style={{
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    {exerData?.exercise_info?.title}
                                  </div>
                                ),
                              )}
                            </div>
                          );
                        } else {
                          return (
                            <div
                              key={index}
                              className="inner-div workout-calendar-exercise-card my-1"
                            >
                              <div style={{ whiteSpace: "break-spaces" }}>
                                {exercise?.exercise_info?.title}
                              </div>
                            </div>
                          );
                        }
                      })}
                    </div>
                  </div>
                )}

                {workout._def.extendedProps.practice_type !== "comment" && (
                  <>
                    <div className="mt-2">
                      {workout._def.extendedProps?.comment && (
                        <div
                          style={{
                            whiteSpace: "break-spaces",
                            fontSize: 10,
                            opacity: 0.8,
                            fontWeight: "500",
                            color: "black",
                          }}
                        >
                          <span
                            style={{
                              fontSize: 10,
                              opacity: 1,
                              fontWeight: "bold",
                              display: "block",
                              color: get_root_value("--portal-theme-primary"),
                            }}
                          >
                            Comment
                          </span>
                          {workout._def.extendedProps?.comment}
                        </div>
                      )}
                    </div>
                    <div className="mt-2">
                      {workout._def.extendedProps?.admin_comment && (
                        <div
                          style={{
                            whiteSpace: "break-spaces",
                            fontSize: 10,
                            opacity: 0.8,
                            fontWeight: "500",
                            color: "black",
                          }}
                        >
                          <span
                            style={{
                              fontSize: 10,
                              opacity: 1,
                              fontWeight: "bold",
                              display: "block",
                              color: get_root_value("--portal-theme-primary"),
                            }}
                          >
                            Reply
                          </span>
                          {workout._def.extendedProps?.admin_comment}
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  const renderEventContent = (eventInfo) => {
    return <EventCard workout={eventInfo.event} />;
  };

  const getEventListing = async (workout) => {
    let all_events = [];
    if (workout.length > 0) {
      all_events = workout.map((workout, i) => {
        return {
          ...workout,
          title: workout.title ? workout.title : "",
          color: workout.program_info?.color,
          workout_color: workout.program_info?.color,
          workout_title: workout.title ? workout.title : "",
          workout_exercises: workout.exercises,
          workout_program: workout.program_info,
          status: workout.status,
          date: moment.utc(workout.workout_date).format("YYYY-MM-DD"),
          index: i,
          order: i,
          open: globalOpenRef.current,
          editable: false,
        };
      });
    }

    const eventsDict = {};
    all_events.forEach((event) => {
      eventsDict[event._id] = event;
    });

    const reorderedEvents = [];
    let remainingEvents = [...all_events];

    reorderedWorkoutList.forEach((workout) => {
      const { workout_date, reorder_workouts } = workout;
      reorder_workouts.forEach((workout_id, index) => {
        if (eventsDict[workout_id]) {
          const event = eventsDict[workout_id];
          event.order = index;
          reorderedEvents.push(event);
          const remainingIndex = remainingEvents.findIndex(
            (e) => e._id === workout_id,
          );
          if (remainingIndex > -1) {
            remainingEvents.splice(remainingIndex, 1);
          }
        }
      });
      const remainingSameDateEvents = remainingEvents.filter(
        (event) => event.workout_date === workout_date,
      );
      remainingSameDateEvents.forEach((event) => {
        reorderedEvents.push(event);
      });
      remainingEvents = remainingEvents.filter(
        (event) => event.workout_date !== workout_date,
      );
    });

    reorderedEvents.push(...remainingEvents);

    let all_reorder_events = reorderedEvents.map((workout, i) => {
      return {
        ...workout,
        title: workout.title ? workout.title : "",
        color: workout.program_info?.color,
        workout_color: workout.program_info?.color,
        workout_title: workout.title ? workout.title : "",
        workout_exercises: workout.exercises,
        workout_program: workout.program_info,
        status: workout.status,
        open: globalOpenRef.current,
        date: moment.utc(workout.workout_date).format("YYYY-MM-DD"),
        index: i,
        order: i,
        editable: false,
      };
    });

    setEvents(all_reorder_events);
  };

  const getCenteredText = () => {
    let text = moment(new Date()).format("MMM YYYY");
    if (calendarRef?.current) {
      const calendarApi = calendarRef?.current.getApi();
      const currentMonth = calendarApi.getDate().getMonth();
      const currentYear = calendarApi.getDate().getFullYear();
      text = moment().month(currentMonth).format("MMM") + " " + currentYear;
    }
    return text;
  };

  const hanldeChangeDates = (value) => {
    let start_date = currentDate.start_date;
    let end_date = currentDate.end_date;
    if (calendarRef?.current) {
      const calendarApi = calendarRef?.current.getApi();
      const currentView = calendarApi.view;
      const startDate = currentView.activeStart;
      const endDate = currentView.activeEnd;
      start_date = startDate;
      end_date = endDate;
    }
    let new_object = {};
    if (value == "next") {
      new_object = {
        start_date: moment(start_date),
        end_date: moment(end_date),
      };
    } else {
      new_object = {
        start_date: moment(start_date),
        end_date: moment(end_date),
      };
    }
    setCurrentDate(new_object);
  };

  const handleChangeNextPrev = (value) => {
    let classToClick = "fc-next-button";
    if (value == "prev") {
      classToClick = "fc-prev-button";
    }
    let click_element = document.getElementsByClassName(classToClick)[0];
    click_element.click();
    hanldeChangeDates(value);
  };

  const handleClickDate = (workout) => {
    setCurrentDate({
      start_date: workout.dateStr,
      end_date: workout.dateStr,
    });
  };

  const renderDayCell = (arg) => {
    return (
      <div
        style={{
          position: "relative",
          height: "100%",
          marginTop: -10,
        }}
      >
        <span>{arg?.dayNumberText}</span>{" "}
        <span className="day-cell-name" style={{ opacity: 0.5, fontSize: 10 }}>
          {moment(arg?.date).format("ddd")}
        </span>
      </div>
    );
  };

  const handleViewGraph = (value) => {
    navigate(`/programmes/calendar/${params.slug}/${value._id}`);
  };

  useEffect(() => {
    if (
      !programme?.member_difficutly_level &&
      programme?._id?.difficulty_level
    ) {
      setOpenLevels(true);
    }
  }, [programme?.member_difficutly_level]);

  useEffect(() => {
    if (!!programme?.open_dashboard) {
      setEditWorkputData({
        ...programme,
        ...programme.program_info,
      });
      handleOpenEditIterationDrawer();
    }
  }, [programme?.open_dashboard]);

  useEffect(() => {
    let start_date = currentDate.start_date;
    let end_date = currentDate.end_date;
    if (calendarRef?.current) {
      const calendarApi = calendarRef?.current.getApi();
      const currentView = calendarApi.view;
      const startDate = currentView.activeStart;
      const endDate = currentView.activeEnd;
      start_date = startDate;
      end_date = endDate;
    }
  }, [calendarRef]);

  useEffect(() => {
    getEventListing(programWorkoutList, time_zone);
  }, [programWorkoutList, submitted]);

  useEffect(() => {
    if (programme?.member_difficutly_level) {
      setDifficultyLevel(programme?.member_difficutly_level);
      setTempDifficultyLevel(programme?.member_difficutly_level);
    }
  }, [programme?.member_difficutly_level]);

  useEffect(() => {
    if (editWorkputData?._id) {
      setTimeout(() => {
        const todayCell = document.querySelector(
          `.calendar-workout-card[id="${editWorkputData?._id}"]`,
        );
        if (todayCell) {
          todayCell.scrollIntoView({ behavior: "instant", block: "center" });
        }
      }, 0);
    }
  }, [events, editWorkputData]);

  const eventOrderFunction = (a, b) => {
    return a.order - b.order;
  };

  if (isLoading === true) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-9 col-12 d-flex align-items-center">
          <IconButton
            className="back-screen-button mb-0 me-2"
            onClick={() => {
              navigate(-1);
              localStorage.removeItem("difficultyLevel");
              localStorage.removeItem("isOpen");
            }}
          >
            <ArrowBackIcon />
          </IconButton>
          <div>
            <h2 className="font-size-on-sm">{calendar_title}</h2>
            {difficultyLevel && (
              <p className="mb-2 text-muted">
                Difficulty Level : {show_proper_words(difficultyLevel)}
              </p>
            )}
          </div>
        </div>

        {programme?._id?.is_harmony_ring_enabled && (
          <div className="col-md-3 col-12 text-end">
            <Button
              variant="contained"
              onClick={() => {
                handleViewGraph(programme?._id);
              }}
            >
              My Compliance
            </Button>
          </div>
        )}

        {/* Row 2: Prev/Next | Month Title | Expand/Collapse/Today */}
        <div className="col-12 mt-2">
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">

            {/* Prev / Next arrows */}
            <div className="d-flex align-items-center gap-2">
              {!hideArrowsAndButtons && (
                <>
                  <div className="btn-group toollbar-group-buttons group-buttons-font-size-on-sm">
                    <button
                      className="small-contained-button"
                      onClick={() => handleChangeNextPrev("prev")}
                    >
                      <ArrowBackIosIcon />
                    </button>
                    <button
                      className="small-contained-button"
                      onClick={() => handleChangeNextPrev("next")}
                    >
                      <ArrowForwardIosIcon />
                    </button>
                  </div>
                  {manualLoading && (
                    <CircularProgress
                      size={20}
                      style={{ verticalAlign: "middle" }}
                    />
                  )}
                </>
              )}
            </div>

            {/* Month / Year label — centered */}
            <h3
              className="font-size-on-sm mb-0 flex-grow-1 text-center"
              style={{ color: "#04abbb" }}
            >
              {getCenteredText()}
            </h3>

            {/* Expand All / Collapse All / Today */}
            <div className="d-flex align-items-center flex-wrap gap-1">
              {events.length > 0 && (
                <>
                  <Button
                    size="small"
                    onClick={handleExpandAll}
                    startIcon={<KeyboardArrowDownIcon />}
                    sx={{
                      bgcolor: "grey.700",
                      color: "#fff",
                      borderRadius: "8px",
                      px: 1,
                      fontSize: "12px",
                      whiteSpace: "nowrap",
                      py: 0.5,
                      minWidth: 0,
                      "&:hover": { bgcolor: "grey.900" },
                    }}
                  >
                    Expand All
                  </Button>

                  <Button
                    size="small"
                    onClick={handleCollapseAll}
                    startIcon={<KeyboardArrowUpIcon />}
                    sx={{
                      bgcolor: "grey.700",
                      color: "#fff",
                      borderRadius: "8px",
                      fontSize: "12px",
                      whiteSpace: "nowrap",
                      px: 1,
                      py: 0.5,
                      minWidth: 0,
                      "&:hover": { bgcolor: "grey.900" },
                    }}
                  >
                    Collapse All
                  </Button>
                </>
              )}
              <div className="group-buttons-font-size-on-sm">
                <button
                  className="small-contained-outlined-button"
                  onClick={() => goToToday()}
                >
                  Today
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div className="row">
        <div className="full-calendar full-calendar-new-flow mt-3">
          <FullCalendar
            ref={calendarRef}
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
            headerToolbar={{
              left: "today prev,next",
              center: "title",
              right: "dayGridMonth,timeGridWeek,timeGridDay",
            }}
            className="fc-day-sun fc-toolbar-chunk fc eventimage fc-col-header-cell-cushion fc-today-button fc-right fc-prev-button fc-right fc-next-button fc-dayGridMonth-button fc-timeGridWeek-button fc-timeGridDay-button fc-daygrid-day-number fc-daygrid-day-top"
            eventContent={renderEventContent}
            events={events}
            initialView="dayGridMonth"
            dayCellContent={renderDayCell}
            editable={true}
            selectable={true}
            selectMirror={true}
            eventOrder={eventOrderFunction}
            weekends={true}
            fixedWeekCount={false}
            height="auto"
            stickyHeaderDates={false}
            moreLinkContent={function (args) {
              return "+" + args.num;
            }}
            moreLinkClick={function (args) {
              handleClickDate(args);
            }}
          />
        </div>
      </div>

      <EditWorkoutPopup
        open={editItrationDrawerState}
        setOpen={setEditItrationDrawerState}
        programme={programme}
        data={editWorkputData}
        reloadList={reloadList}
        member_vdot={member_vdot}
        memberRewardData={memberRewardData}
        setEvents={setEvents}
        setEditWorkputData={setEditWorkputData}
        events={events}
        setSubmitted={setSubmitted}
      />

      <CustomPopoverNew
        is_hide_icon={programme?.member_difficutly_level ? false : true}
        width="550px"
        isOpenPop={openLevels}
        isClosePop={() => {
          setOpenLevels(false);
          setTempDifficultyLevel("");
        }}
        title={"Difficulty Levels"}
        componentToPassDown={
          <div className="px-4 pb-3">
            <FormControl fullWidth sx={{ mb: 2, mt: 2 }} required>
              <InputLabel id="demo-simple-select-label">
                Difficulty Levels
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                name="difficulty_levels"
                value={tempDifficultyLevel}
                label="Difficulty Levels"
                onChange={(e) => {
                  setTempDifficultyLevel(e.target.value);
                }}
              >
                <MenuItem value="novice">Novice</MenuItem>
                <MenuItem value="intermediate">Intermediate</MenuItem>
                <MenuItem value="advanced">Advanced</MenuItem>
              </Select>
            </FormControl>

            {tempDifficultyLevel && (
              <div
                style={{
                  backgroundColor: "#f5f5f5",
                  padding: "12px",
                  borderRadius: "8px",
                  marginBottom: "16px",
                  textAlign: "center",
                  fontSize: "16px",
                  fontWeight: "500",
                  color: "#333",
                }}
              >
                You will have <strong>{getWorkoutCountForLevel()}</strong>{" "}
                workouts with{" "}
                <strong>{show_proper_words(tempDifficultyLevel)}</strong>{" "}
                difficulty
              </div>
            )}

            <div className="mb-2" style={{ width: "500px", maxWidth: "100%" }}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox checked={checked} onChange={handleChangeCheck} />
                  }
                  label="Workouts with your selected difficulty level will be assigned to you for this programme. (To change it, please submit a support ticket.)"
                  sx={{
                    "& .MuiFormControlLabel-label": {
                      color: "gray",
                      fontSize: "14px",
                    },
                  }}
                />
              </FormGroup>
            </div>

            <div className="text-end">
              <Button
                variant="contained"
                disabled={!checked}
                onClick={handleAddLevels}
              >
                Save
              </Button>
            </div>
          </div>
        }
      />
    </div>
  );
}

export default GeneralCalendar;
